import { FinanceSettingsOrganization } from '@/shared/forms/FinanceSettingsForm/domain/groupLineItemsByOrganization.ts';

export function isNotTransportExchangeOrganization(
    organization: FinanceSettingsOrganization
): organization is FinanceSettingsOrganization & { organizationId: number } {
    return organization.organizationId !== 'TRANSPORT_EXCHANGE';
}
